module.exports = __webpack_public_path__ + "img/Real-Valladolid.e7802b90.png";